import { SET_PROGRAMS, SET_PROGRAM, SET_SUGGESTED_PROGRAMS, SET_PROGRAM_WORKOUTS } from "./types";
import { apiCallV2, servicesAPICall } from "../../../utils/api";

export const GetPrograms = (filter = null) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "GET",
        "get-programs",
        "",
        localStorage.getItem("access-token"),
        filter
    );


    if (res?.status === 200) {

        const { program } = getState().Program;


        dispatch({
            type: SET_PROGRAMS,
            data: [...res?.data.data]
        })

        if (!program) {

            dispatch({
                type: SET_PROGRAM,
                data: { ...res?.data.data[0] }
            })
        }
    } else if (!res?.status) {
        const res2 = await apiCallV2(
            "GET",
            "get-programs",
            "",
            localStorage.getItem("access-token"),
            filter
        );

        const { program } = getState().Program;
        dispatch({
            type: SET_PROGRAMS,
            data: [...res2?.data.data]
        })

        if (!program) {
            dispatch({
                type: SET_PROGRAM,
                data: { ...res2?.data.data[0] }
            })
        }
    }

    if (filter != null && filter.hasOwnProperty("id")) {
        dispatch({
            type: SET_PROGRAM,
            data: { ...res?.data.data[0] }
        })
    }
}


export const GetSuggestedPrograms = (filter = null) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "GET",
        "get-user-survey-for-cognosis",
        "",
        localStorage.getItem("access-token"),
        filter
    );

    const results = res?.data?.data?.results || [];
    let programs = [];


    for (let x = 0; x < results?.length; x++) {
        programs.push({
            id: results?.[x].program,
            level: results?.[x].level || 1,
        })
    }

    if (res.status === 200) {

        dispatch({
            type: SET_SUGGESTED_PROGRAMS,
            data: programs,
        })

    }
}

export const GetSuggestedPrograms2 = (filter = null) => async (dispatch, getState) => {

    const { patientEmailDetails } = getState().User;

    const res = await servicesAPICall(
        "GET",
        "embeddings/program-recommendation",
        "",
        localStorage.getItem("access-token"),
        {
            emailedSuggestedPrograms: patientEmailDetails?.suggested_programs || null
        }
    );
    const results = res?.data?.data?.results || [];
    let programs = [];


    for (let x = 0; x < results?.length; x++) {
        programs.push({
            id: results?.[x].program_id_2,
            level: results?.[x].level || 1,
        })
    }

    if (res?.status === 200) {

        dispatch({
            type: SET_SUGGESTED_PROGRAMS,
            data: programs,
        })

    }
}





export const SetSelectedProgram = (data) => async (dispatch, getState) => {

    if (typeof data !== "object") {
        const { programs } = getState().Program;
        data = programs.filter(prog => prog.id === data)[0];
    }

    dispatch({
        type: SET_PROGRAM,
        data: { ...data }
    })
}
export const SendProgramGuide = (programLevel, program, name, email) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "send-program-guide",
        {
            type: programLevel,
            program: program,
            name: name,
            email: email,
        },
        localStorage.getItem("access-token"),
    );

    if (res.status === 200) {
        return true
    } else {
        return false
    }

}